import React from 'react'
import { Text, Box, List, ListItem, OrderedList } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router-dom';
function Instructions() {
    const { integration } = useOutletContext()
    const { t } = useTranslation();
    return (
        <>
            <Box flexDirection={'column'} width={'48vw'} gap={'2vh'} display={'flex'} >
                <Text fontSize={'1.4vw'} >Instructions. </Text>
                <Text fontSize={'0.9vw'} > {t('follow.code.steps')} </Text>
                <OrderedList fontSize={'0.9vw'} >
                    <ListItem>
                        <Text fontSize={'0.9vw'} > {t('integration.step1.1')} {integration?.entity} {t('integration.step1.2')} </Text>
                    </ListItem>
                    <ListItem>
                        <Text fontSize={'0.9vw'} > {t('integration.step2')}</Text>
                    </ListItem>
                </OrderedList>
                <Text fontSize={'0.9vw'} > {t('integration.unsure')} </Text>
            </Box>
        </>
    )
}

export default Instructions